import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT_QUERY = '(max-width: 767px)';

const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia(MOBILE_BREAKPOINT_QUERY).matches,
  );

  useEffect(() => {
    const mediaQueryList = window.matchMedia(MOBILE_BREAKPOINT_QUERY);
    setIsMobile(mediaQueryList.matches);

    const handleChange = (event: Pick<MediaQueryListEvent, 'matches'>) =>
      setIsMobile(event.matches);

    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
